import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { API_SERVER, GetSession } from '../../EnvConfig/env_config';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, convertToNumber, handleDateChange } from '../CommonComponents/CustomHooks';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { AutoCompleteBox, DateBox, FormButton, InputBox, Radio, base64ToBlob } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { autoCompleteDelay } from '../../config';

const PickUpReport = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch([])
    const [isLoading, setIsLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [tableData, setTableData] = useState([])
    const [isUpdate, setisUpdate] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const Branchcode = GetSession('cookies', 'branchCode');
    const bcode = Branchcode.split(" : ")[0]
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const selectedDate = new Date();
    selectedDate.setDate(selectedDate.getDate() - 14);
    const selectedDate2 = new Date();
    selectedDate2.setDate(selectedDate2.getDate());
    const dateArr = selectedDate.toDateString().split(" ");
    const formattedDate = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;
    const dateArr2 = selectedDate2.toDateString().split(" ");
    const formattedDate1 = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    const [formData, setFormData] = useState({
        bookingDateFrom: formattedDate,
        bookingDateTo: formattedDate1,
        cCode: '',
        awbNo: '',
        bookedBy: '',
        PickupInScan: false,
        PickupNotInScan: false,
        IsCancel: false,
        allRecord: true,
    });
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    const getPickUpReportData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setIsLoading(true)
        let data = await ApiCall('/api/Report/ShowPickUpReport', GetData)
        setTableData(data)
        setIsLoading(false)
        if (data.Status === 'ERROR' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
       
    }
    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };
    const handleClear = () => {
        setFormData({
            bookingDateFrom: formattedDate,
            bookingDateTo: formattedDate1,
            cCode: '',
            awbNo: '',
            bookedBy: '',
            PickupInScan: false,
            PickupNotInScan: false,
            IsCancel: false,
            allRecord: true,
        });
        setisUpdate(!isUpdate)
        getPickUpReportData()
    }
    const handlePrint = async (value) => {
        await dispatch(setSubLoading(true))
        let imgresult = await ApiCall('/api/Report/PickupPrint', { PickupReferenceNo: value });
        await dispatch(setSubLoading(false))
        let result = imgresult;
        if (result.status === 'ERROR' || result.status === 'EXPIRED') {
            await NotificationSound(result.status, result.message, result.focus, inputrefs, handleClear);
            await dispatch(setSubLoading(false))
        }
        const blob = base64ToBlob(result.documentPdfBase64?.split(',')[1], 'application/pdf');
        const url = URL.createObjectURL(blob);
        const PDFWindow = window.open("");
        PDFWindow.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>");
    }
    const handleChange1 = (event, value) => {
        getPickUpReportData(value);
    };
    const handleClick = (value) => {
        window.open(`/PickUpRequest?AwbNo=${value.trim()}`, '_blank');

    }
    useEffect(() => {
        getPickUpReportData()
    }, [sortConfig])
    useEffect(() => {
        getPickUpReportData()
        document.title = 'Pick Up Report'
        inputrefs.current['txtFromDate'].focus()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUpdate])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {FindTranslatedKey('Pick Up Report')} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <DateBox
                                inputrefs={inputrefs}
                                label="Booking Date From"
                                placeholder="Booking Date From"
                                id='txtFromDate'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtToDate'].focus()
                                    };
                                }}
                                required={false}
                                selected={formData.bookingDateFrom === '' ? '' : new Date(formData.bookingDateFrom)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'bookingDateFrom')}
                            />
                            <DateBox
                                inputrefs={inputrefs}
                                label="Booking Date To"
                                placeholder="Booking Date To"
                                id='txtToDate'
                               // value={formData.bookingDateTo ? formData.bookingDateTo : ''}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtclient'].focus()
                                    };
                                }}
                                required={false}
                                selected={formData.bookingDateTo === '' ? '' : new Date(formData.bookingDateTo)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'bookingDateTo')}
                            />
                            {/*<InputBox*/}
                            {/*    id="txtclient"*/}
                            {/*    type="text"*/}
                            {/*    label='Client Code'*/}
                            {/*    onKeyDown={(e) => {*/}
                            {/*        if (e.key === 'Enter') {*/}
                            {/*            inputrefs.current['txtAWBBill'].focus()*/}
                            {/*        }*/}
                            {/*    }}*/}
                            {/*    inputrefs={inputrefs}*/}
                            {/*    placeholder='Client Code'*/}
                            {/*    name='Client Code'*/}
                            {/*    value={formData.cCode}*/}
                            {/*    onChange={(e) => setFormData({ ...formData, cCode: e.target.value })}*/}
                            {/*/>*/}
                            <AutoCompleteBox
                                label='Client'
                                placeholder='Client'
                                inputValue={formData.cCode}
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, bcode, 'GetClient');
                                        setFormData({ ...formData, cCode: newInputValue })
                                    }
                                }
                                inputrefs={inputrefs}
                                id='txtclient'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAWBBill'].focus()
                                    }
                                }}
                            />
                            <InputBox
                                id="txtAWBBill"
                                PlaceHolderText="AWB No."
                                autoComplete="off"
                                maxLength='25'
                                required={false}
                                label='AWB No.'
                                value={formData.awbNo}
                                onChange={(e) => {
                                    setFormData({ ...formData, awbNo: e.target.value })
                                }}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBookedBy'].focus()
                                    }
                                }}
                            />
                           
                            <AutoCompleteBox
                                label='Booked By'
                                placeholder='Booked By'
                                inputValue={formData.bookedBy}
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, '', 'GetBookedBy');
                                        setFormData({ ...formData, bookedBy: newInputValue })
                                    }
                                }
                                inputrefs={inputrefs}
                                id='txtBookedBy'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAll'].focus()
                                    }
                                }}
                            />
                            <Radio
                                label='All'
                                inputrefs={inputrefs}
                                id='txtAll'
                                checked={formData.allRecord}
                                onChange={(e) => setFormData({
                                    ...formData, allRecord: e.target.checked, PickupInScan: false,
                                    PickupNotInScan: false, IsCancel: false,
                                })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtPickupInScan'].focus() };
                                }}
                            />

                            <Radio
                                label='Pickup In Scan'
                                inputrefs={inputrefs}
                                id='txtPickupInScan'
                                checked={formData.PickupInScan}
                                onChange={(e) => setFormData({
                                    ...formData, PickupInScan: e.target.checked,
                                    PickupNotInScan: false,
                                    IsCancel: false,
                                    allRecord: false,
                                })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtPickupNotInScan'].focus() };
                                }}
                            />
                            <Radio
                                label='Pickup Not In Scan'
                                inputrefs={inputrefs}
                                id='txtPickupNotInScan'
                                checked={formData.PickupNotInScan}
                                onChange={(e) => setFormData({
                                    ...formData, PickupNotInScan: e.target.checked, PickupInScan: false,
                                    IsCancel: false,
                                    allRecord: false,
                                })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtIsCancel'].focus() };
                                }}
                            />
                            <Radio
                                label='Is Cancelled'
                                inputrefs={inputrefs}
                                id='txtIsCancel'
                                checked={formData.IsCancel}
                                onChange={(e) => setFormData({
                                    ...formData, IsCancel: e.target.checked, PickupInScan: false,
                                    PickupNotInScan: false, allRecord: false,
                                })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                                }}
                            />
                           
                        </div>
                    </div>
                    <div className='card-body mt-2'>
                        <FormButton
                            id={'btnSave'}
                            Search={true}
                            save={false}
                            inputrefs={inputrefs}
                            handleSubmit={getPickUpReportData}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                handleDownloadExcel(`/api/Report/ShowPickUpReport`, formData, 'Pick Up Report')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                PageName={'PickUpReport'}
                loading={isLoading}
                Filter={false}
                tableData={tableData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
                matchingkey={'ReferenceNo'}
                handlePrint={handlePrint}
                ClickOnLink={handleClick}
            />
        </>
    )
}
export default PickUpReport;